import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useFoodList() {
    const { t } = useI18nUtils()
    const isGuideFormSidebarActive = ref(false)
    const guideData = ref(null)
    const toast = useToast()
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const currentPage = ref(1)
    const searchQuery = ref('')
    const guides = ref([]);
    const catagoriesData = ref([])
    const statusFilter = ref(null)
    const catagoryFilter = ref(null)
    const totalGuides = ref(0)
    const refGuideListTable = ref(null)
    const contentsData = ref(null);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'name', label: 'Guide Name', sortable: false },
        { key: 'rating', label: 'Rating', sortable: false },
        { key: 'category', label:'Category', sortable:false},
        { key: 'show_site', label:'Show In Site', sortable:false},
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ]
    const dataMeta = computed(() => {
        if (!totalGuides.value || totalGuides.value === 0) {
            return { from: 0, to: 0, of: 0 };
        }
    
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(totalGuides.value, perPage.value * currentPage.value);
    
        return {
            from,
            to,
            of: totalGuides.value,
        };
    });

    store.dispatch('app-guides/getGuideCategories')
        .then(response => {
            catagoriesData.value = response.data.data
    })

    const updateGuidesOrdering = () => {
        const filteredData = guides.value?.filter(item => item !== undefined);

        store.dispatch('app-guides/updateGuidesOrdering', filteredData)
    }

    const resolveCatagoryStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveCatStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter, catagoryFilter], () => {
        fetchData()
    })

    const updateGuide = async (data) => {
        if(data){
            guideData.value = data
        } else {
            guideData.value = null;
            contentsData.value  = [];
        }
        
        isGuideFormSidebarActive.value = true
        fetchData()
    }

    const fetchData = (ctx, callback) => {
        const offset = (currentPage.value - 1) * perPage.value;

        store.dispatch(`app-guides/getGuides`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'id ASC',
            category_id: catagoryFilter.value
        })
        .then(response => {
            const data = response.data.data
            guides.value = setGuideData(data)

            totalGuides.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Guide' lists",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const setGuideData = (guides) => {
        return guides.slice().sort(function (a, b) {
            return a.ordering_count - b.ordering_count;
        });
    }

    const deleteData = async (id) => {
        await store.dispatch('app-guides/deleteGuide', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Guide",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        isGuideFormSidebarActive,
        guideData,
        refetchData,
        fetchData,
        tableColumns,
        searchQuery,
        dataMeta,
        guides,
        // t,
        resolveCatagoryStatusVariant,
        resolveCatStatusnameVariant,
        updateGuide,
        statusFilter,
        catagoryFilter,
        catagoriesData,
        totalGuides,
        perPage,
        perPageOptions,
        refGuideListTable,
        currentPage,
        deleteData,
        updateGuidesOrdering,
    }
}